// Stats.js

function Stats() {
  return (
    <section className="stats">
      <div className="stats-container">
        <div className="stat-item">
          <div className="stat-number">100K+</div>
          <div className="stat-label">Happy Players</div>
        </div>
        <div className="stat-item">
          <div className="stat-number">50+</div>
          <div className="stat-label">Games</div>
        </div>
        <div className="stat-item">
          <div className="stat-number">$0</div>
          <div className="stat-label">Money Required</div>
        </div>
        <div className="stat-item">
          <div className="stat-number">24/7</div>
          <div className="stat-label">Available</div>
        </div>
      </div>
    </section>
  );
}

export default Stats;